module.exports = __webpack_public_path__ + "../resources/images/no_search_room_results_opx-5239f5d42094db150f8a31179fc715f1.svg";